import { dispatch } from "../store";
import { SET_CURRENT_USER } from "./constants";

export const updateNumRequestChange = (currentUser, numChange) => {
    dispatch({
        type: SET_CURRENT_USER,
        payload: {
            ...currentUser,
            numChangeRequest: (currentUser.numChangeRequest || 0) + numChange
        },
    });
};